"use strict";
/** state: Final  **/
/** family: Modal **/
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var trackMetric_1 = require("../../metrics/trackMetric");
var CloseButton_1 = require("../CloseButton");
/**
 * Header for a Modal
 *
 * Re-implemented so that we can ensure the header titles are
 * rendered before the close button and so that they are screen readable
 */
var ModalHeader = function (_a) {
    var className = _a.className, closeLabel = _a.closeLabel, onHide = _a.onHide, metricOptions = _a.metricOptions, children = _a.children, restProps = __rest(_a, ["className", "closeLabel", "onHide", "metricOptions", "children"]);
    return (React.createElement("div", __assign({ className: classNames('modal-header', className) }, restProps),
        children,
        !!closeLabel && (React.createElement(CloseButton_1.CloseButton, { label: closeLabel, onClick: trackMetric_1.trackMetric(metricOptions, onHide) }))));
};
exports.ModalHeader = ModalHeader;
//# sourceMappingURL=ModalHeader.js.map